import React from 'react';
import AutoSuggestListItem from './AutoSuggestListItem/AutoSuggestListItem';
import classes from './AutoSuggestList.scss';

const autoSuggestList = (props) => {
    
    let listView = null;

    if (props.airportDataUpdated) {
        listView = props.airportDataUpdated.map((airport, index) => {
            return <AutoSuggestListItem 
                key={index} 
                city={airport.city} 
                country={airport.country}
                flights={airport.flight}
                cityClicked={props.selectCity}
                type={props.type}
                active={ props.activeItem === index ? true : false}
                hoverInHandler={props.hoverInHandler}
                hoverOutHandler={props.hoverOutHandler}
                itemIndex={index}
                listType={'flight'}
                />
        });
    } else if (props.hotelsDataUpdated) {
        listView = props.hotelsDataUpdated.map((hotels, index) => {
            if (props.hotelsDataUpdated.length - 1 !== index) {
                if (props.hotelsDataUpdated[index].type !== props.hotelsDataUpdated[index + 1].type) {
                    return <React.Fragment>
                        <p className={`u-fontSize11 u-textColorDark u-fontWeightMedium mb-4 pt-4 pl-8 u-borderTopNormal`}>{props.hotelsDataUpdated[index + 1].type}</p>
                        <AutoSuggestListItem 
                            cities={hotels}
                            key={index}
                            active={ props.activeItem === index ? true : false}
                            hoverInHandler={props.hoverInHandler}
                            hoverOutHandler={props.hoverOutHandler}
                            cityClicked={props.selectCity}
                            itemIndex={index}
                            listType={'hotel'}
                        />
                    </React.Fragment>
                }
            } 
            return <React.Fragment>
                { index === 0 ? <p className={`u-fontSize11 u-textColorDark u-fontWeightMedium pb-2 pt-4 pl-8`}>{props.hotelsDataUpdated[index].type}</p> : null }
                <AutoSuggestListItem 
                        cities={hotels}
                        key={index}
                        active={ props.activeItem === index ? true : false}
                        hoverInHandler={props.hoverInHandler}
                        hoverOutHandler={props.hoverOutHandler}
                        cityClicked={props.selectCity}
                        itemIndex={index}
                        listType={'hotel'}
                    />  
            </React.Fragment>
        });
    }

    return (
        <ul className={classes.AutoSuggestList}>
            {listView}
        </ul>
    );
}

export default autoSuggestList;


// WEBPACK FOOTER //
// ./src/components/UI/AutoSuggestBox/AutoSuggestList/AutoSuggestList.js